module.exports = __webpack_public_path__ + "img/silk.bd93059c.jpg";